<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners" class="pl-0 mr-2">
    <span slot="title">
      <a-icon v-if="menuInfo.icon" :type="menuInfo.icon"></a-icon>
      <span :class="styles.title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
    </span>
    <template v-for="item in menuInfo.children">
      <item v-if="(!item.children && !item.divider) && (
        item.key !== 'unified-collection' ||
        userCanView(user, item.key)
      )" :menu-info="item" :styles="styles" :key="item.key" />
      <sub-menu v-if="item.children" :menu-info="item" :styles="styles" :key="item.key" />
    </template>
  </a-sub-menu>
</template>

<script>
import { Menu } from 'ant-design-vue'
import Item from './item'
import accessMix from '@/services/accessmix.js'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SubMenu',
  mixins: [accessMix],
  components: { Item },
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: Object,
    styles: Object,
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters('user', ['user']),
  },
}
</script>
